// frontend/src/components/ModeTestBandeau.jsx - VERSION ULTRA-SÉCURISÉE
import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Bandeau jaune MODE TEST qui s'affiche en haut de toutes les pages
 * UNIQUEMENT si mode_test = 'oui' dans la config
 * 
 * PROTECTION TOTALE : Ne plante jamais, même si config est undefined/null
 */
const ModeTestBandeau = ({ config }) => {
  // ⚡ PROTECTION #1 : Config pas encore chargée
  if (!config) {
    return null; // Ne rien afficher, pas d'erreur
  }

  // ⚡ PROTECTION #2 : mode_test n'existe pas ou n'est pas 'oui'
  if (config.mode_test !== 'oui') {
    return null; // Mode normal, pas de bandeau
  }

  // ✅ Afficher le bandeau uniquement si mode_test = 'oui'
  return (
    <div className="bg-yellow-400 border-b-4 border-yellow-600 py-3 px-4 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
        <AlertTriangle className="h-6 w-6 text-yellow-900 animate-pulse" />
        <div className="text-center">
          <p className="text-yellow-900 font-bold text-lg">
            ⚡ MODE TEST ACTIVÉ
          </p>
          <p className="text-yellow-800 text-sm">
            Les contraintes de workflow sont désactivées • Toutes les transitions sont autorisées
          </p>
        </div>
        <AlertTriangle className="h-6 w-6 text-yellow-900 animate-pulse" />
      </div>
    </div>
  );
};

export default ModeTestBandeau;